/** @format */

import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: right;
  align-self: flex-end;

  @media screen and (max-width: 375px) {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`;

export const IconWrapper = styled.div<{ isPopup?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isPopup }) => !isPopup && 'flex-end'};
  height: ${({ isPopup }) => isPopup && '1.5rem'};
  gap: 0.25rem;
  span {
    color: var(--gray-900);
    text-align: right;

    font-family: ${({ theme }) => theme.font.body};
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 300;
    line-height: 1.25rem;
  }
`;

export const AvailabilityStatus = styled.div<{ isPopup?: boolean }>`
  p {
    color: var(--gray-900);
    text-align: ${({ isPopup }) => !isPopup && 'right'};
    font-family: ${({ theme }) => theme.font.body};
    font-size: 0.875rem;
    margin: 0;
    font-style: normal;
    line-height: 1.25rem;
    white-space: ${({ isPopup }) => !isPopup && 'nowrap'};

    &.green,
    &.green .today {
      color: var(--Success-600, #039855) !important;
    }
  }
  span {
    font-weight: 600;
  }
`;
